import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";

// import Abouts from "./pages/Abouts";
import Faqs from "./pages/Faqs";
import Contacts from "./pages/Contacts";


import HomeRegist from './pages/registration/homeregist';
import HomeIndo from './pages/registration/homeindo';
import IndonesiaOffline from './pages/registration/indo-offline';
import IndonesiaOnline from './pages/registration/indo-online';
import HomeInter from './pages/registration/homeinter';
import InternationalOffline from './pages/registration/inter-offline';
import InternationalOnline from './pages/registration/inter-online';
import Lowtahun from "./pages/low/lowtahun";
import Certtahun from "./pages/certificate/certtahun";
import CurationTahun from "./pages/curation/CurationTahun";
import News from "./pages/News";

import Kategori25 from "./pages/low/2025/kategori25";
import Jenjangofl25 from "./pages/low/2025/jenjangofl25";
import Jenjangonl25 from "./pages/low/2025/jenjangonl25";

import Kategori26 from "./pages/low/2026/kategori26";
import Jenjangofl26 from "./pages/low/2026/jenjangofl26";
import Jenjangonl26 from "./pages/low/2026/jenjangonl26";

import ThankyouPage from "./pages/registration/thankyou";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/About" element={<Abouts />} />\ */}
          <Route path="/Faqs" element={<Faqs />} />
          <Route path="/Contacts" element={<Contacts />} />


          <Route path="/homeregist" element={<HomeRegist/>} />
            <Route path="/homeindo" element={<HomeIndo/>} />
            <Route path="/indooffline" element={<IndonesiaOffline/>} />
            <Route path="/indoonline" element={<IndonesiaOnline/>} />
            <Route path="/homeinter" element={<HomeInter/>} />
            <Route path="/interoffline" element={<InternationalOffline/>} />
            <Route path="/interonline" element={<InternationalOnline/>} />
            <Route path="/thankyou" element={<ThankyouPage/>} />
            <Route path="/listofwinner" element={<Lowtahun/>} />
            <Route path="/news" element={<News/>} />
            <Route path="/certificatesupervisor" element={<Certtahun/>} />
            <Route path="/Curation/:tahun" element={<CurationTahun />} />
            <Route path="/kategori25" element={<Kategori25 />} />
            <Route path="/jenjangofl25" element={<Jenjangofl25 />} />
            <Route path="/jenjangonl25" element={<Jenjangonl25 />} />
            <Route path="/kategori26" element={<Kategori26 />} />
            <Route path="/jenjangofl26" element={<Jenjangofl26 />} />
            <Route path="/jenjangonl26" element={<Jenjangonl26 />} />

        </Routes>
      </Router>
    </>
  );
}

export default App;
